export const mediaPath = () => {
    return process.env.PUBLIC_URL + "/media/helper-assets";
};